import { render, staticRenderFns } from "./SubscriptionForm.Purchase.NowPaymentsForm.vue?vue&type=template&id=5f7074cc&scoped=true&"
import script from "./SubscriptionForm.Purchase.NowPaymentsForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.NowPaymentsForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Purchase.NowPaymentsForm.vue?vue&type=style&index=0&id=5f7074cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7074cc",
  null
  
)

export default component.exports